import axios from "../shared/axios/index";
import { API_ROUTES, REACT_APP_API_URL } from "../config/api-config";

export const apiBaseUrl = REACT_APP_API_URL;

// ============================================================
// PEOPLE COUNTING CUSTOM SERVICES
// ============================================================
export const getPeopleCountingDataService = (body) => {
  return axios.post(`${API_ROUTES.get_people_counting_analytics}`, body);
};

// ============================================================
// LOGIN (NO AUTH NEEDED)
// ============================================================
export const loginService = (body) => {
  return axios.post(`${API_ROUTES.login}`, body, {
    headers: {
      "content-Type": "application/x-www-form-urlencoded",
    },
  });
};
export const get_all_suspects = () => {
  const token = localStorage.getItem("accessToken");
  return axios.get(`${REACT_APP_API_URL}/suspects/all`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const delete_suspect = (suspect_id) => {
  const token = localStorage.getItem("accessToken");
  return axios.delete(`${REACT_APP_API_URL}/suspects/delete/${suspect_id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
export const update_user_alerts = (alertData) => {
  const token = localStorage.getItem("accessToken");
  return axios.put(`${REACT_APP_API_URL}/users/update_alerts`, alertData, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const get_suspect_report = (data) => {
  return axios.post('/suspects/report', data);
};
export const update_suspect = (suspect_id, payload) => {
  const token = localStorage.getItem("accessToken");
  return axios.put(`${REACT_APP_API_URL}/suspects/update/${suspect_id}`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
export const get_home_page_summary = async (payload) => {
  try {
    const response = await axios.post(`${API_ROUTES.get_home_page_summary}`, payload);
    return response;
  } catch (error) {
    console.error("Error fetching home page summary:", error);
    throw error;
  }
};
export const update_student_notification = (student_id, is_notification) => {
  const token = localStorage.getItem("accessToken");
  return axios.put(`${REACT_APP_API_URL}/students/update_notification/${student_id}`, 
    { is_notification: is_notification }, 
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const update_staff_notification = (staff_id, is_notification) => {
  const token = localStorage.getItem("accessToken");
  return axios.put(`${REACT_APP_API_URL}/staff/update_notification/${staff_id}`, 
    { is_notification: is_notification }, 
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const getStaffLeavesService = async () => {
  return axios.get(API_ROUTES.get_staff_leaves);
};

export const updateStaffLeaveService = async (leaveId, leaveData) => {
  return axios.put(`${API_ROUTES.update_staff_leave}/${leaveId}`, leaveData);
};
export const addSuspectService = (body) => {
  return axios.post(`${API_ROUTES.add_suspect}`, body);
};
export const deleteStaffLeaveService = async (leaveId) => {
  return axios.delete(`${API_ROUTES.delete_staff_leave}/${leaveId}`);
};

export const addStaffLeaveService = async (leaveData) => {
  try {
    const response = await axios.post(API_ROUTES.add_staff_leave, leaveData);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getStudentLeavesService = async () => {
  return axios.get(API_ROUTES.get_student_leaves);
};
export const scanNetworkService = (subnetParam) => {
    const query = subnetParam ? `?subnet=${subnetParam}` : '';
    return axios.get(`/camera/scan_network${query}`);
};

export const testRtspService = (body) => {
    return axios.post(`/camera/test_rtsp_stream`, body);
};
export const updateStudentLeaveService = async (leaveId, leaveData) => {
  return axios.put(`${API_ROUTES.update_student_leave}/${leaveId}`, leaveData);
};

export const deleteStudentLeaveService = async (leaveId) => {
  return axios.delete(`${API_ROUTES.delete_student_leave}/${leaveId}`);
};

export const addStudentLeaveService = async (leaveData) => {
  try {
    const response = await axios.post(API_ROUTES.add_student_leave, leaveData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_member_attendance_summary = async (payload) => {
  try {
    const response = await axios.post(
      `/events/get_member_attendance_summary`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const download_member_pdf = async (payload) => {
  try {
    const response = await axios.post(
      `/events/download_member_pdf`,
      payload,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getHolidaysByMonth = async (year, month) => {
  try {
    const response = await axios.get(`/api/holidays`, {
      params: { year: year, month: month }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const checkIsHoliday = async (dateStr) => {
  try {
    const response = await axios.get(`/api/holidays/check/${dateStr}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createHoliday = async (holidayData) => {
  try {
    const response = await axios.post(`/api/holidays`, holidayData);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAllHostels = async () => {
  try {
    const response = await axios.get(`${API_ROUTES.get_all_hostels}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudentsByHostel = async (hostel) => {
  try {
    const response = await axios.get(
      `${API_ROUTES.get_students_by_hostel}?hostel=${encodeURIComponent(hostel)}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteHoliday = async (holidayId) => {
  try {
    const response = await axios.delete(`/api/holidays/${holidayId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getDateExceptionsRangeBulk = async (startDate, endDate) => {
  try {
    const response = await axios.get(`/api/date-exceptions/range/bulk`, {
      params: { start_date: startDate, end_date: endDate }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveDateExceptionsService = async (exceptionData) => {
  try {
    const response = await axios.post(`/api/date-exceptions`, exceptionData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveHolidayExceptionsService = async (exceptionData) => {
  try {
    const response = await axios.post(`/api/holidays/exceptions`, exceptionData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getHolidayExceptionsService = async (holidayId) => {
  try {
    const response = await axios.get(`/api/holidays/${holidayId}/exceptions`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const checkSectionClosedService = async (holidayId, section) => {
  try {
    const response = await axios.get(
      `/api/holidays/${holidayId}/section-status/${section}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const checkStudentHolidayStatusService = async (holidayId, studentId) => {
  try {
    const response = await axios.get(
      `/api/holidays/${holidayId}/student-status/${studentId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getHolidaysBySection = async (section) => {
  try {
    const response = await axios.get(`/api/holidays/section/${section}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudentHolidaysService = async (studentId, year = null, month = null) => {
  try {
    const params = {};
    if (year) params.year = year;
    if (month) params.month = month;
    const response = await axios.get(`/api/holidays/student/${studentId}`, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const bulkUploadHolidays = async (holidaysArray) => {
  try {
    const response = await axios.post(`/api/holidays/bulk/upload`, holidaysArray);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateHoliday = async (holidayId, updateData) => {
  try {
    const response = await axios.put(`/api/holidays/${holidayId}`, updateData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const addCameraService = (body) => {
  return axios.post(`${API_ROUTES.add_camera}`, body);
};
export const deleteCameraService = (body) => {
  return axios.post(`${API_ROUTES.delete_camera}`, body);
};
export const getCameraListService = () => {
  return axios.get(`${API_ROUTES.get_cameras}`);
};
export const getAllModelNamesService = () => {
  return axios.get(`${API_ROUTES.model_names}`);
};
export const addOrUpdateAreaSelectionService = (body) => {
  return axios.post(`${API_ROUTES.save_area_selection}`, body);
};
export const deleteAreaSelectionService = (body) => {
  return axios.post(`${API_ROUTES.delete_area_settings}`, body);
};
export const getAllAreaSelectionService = () => {
  return axios.get(`${API_ROUTES.get_model_settings}`);
};
export const getCameraImageService = (body) => {
  return axios.post(`${API_ROUTES.get_camera_image}`, body);
};
export const getAllLocationsService = async () => {
  try {
    return axios.get(`${API_ROUTES.get_all_locations}`);
  } catch (error) {
    throw error;
  }
};
export const getCamerasByLocationService = async (location) => {
  try {
    return axios.get(`${API_ROUTES.get_cameras_by_location}?location=${location}`);
  } catch (error) {
    throw error;
  }
};
export const getAllCamerasService = () => {
  return axios.get(`${API_ROUTES.get_cameras}`);
};

export const addCourseService = (body) => {
  return axios.post(`${API_ROUTES.add_course}`, body);
};
export const getCourseListService = () => {
  return axios.get(`${API_ROUTES.get_courses}`);
};
export const deleteCourseService = (body) => {
  return axios.post(`${API_ROUTES.delete_course}`, body);
};

export const createSessionService = (body) => {
  return axios.post(`${API_ROUTES.create_session}`, body);
};
export const getSessionService = () => {
  return axios.get(`${API_ROUTES.get_sessions}`);
};
export const editSessionService = (body) => {
  return axios.post(`${API_ROUTES.edit_session}`, body);
};
export const deleteSessionService = (body) => {
  return axios.post(`${API_ROUTES.delete_session}`, body);
};

export const get_attendance_summary = (body) => {
  return axios.post(`${API_ROUTES.get_attendance_summarys}`, body);
};

export const get_location_report = async (body) => {
  return axios.post(`${API_ROUTES.get_location_report}`, body);
};

export const get_session_attendance_status = async (body) => {
  return axios.post(`${API_ROUTES.get_session_attendance_status}`, body);
};

export const get_locations_by_date = async (body) => {
  return axios.post(`${API_ROUTES.get_locations_by_date}`, body);
};

export const download_attendance_pdf = async (body) => {
  return axios.post(`${API_ROUTES.download_attendance_pdf}`, body);
};

export const downloadEventListCsvService = (body) => {
  return axios.post(`${API_ROUTES.download_csv}`, body);
};
export const downloadEventListPdfService = (body) => {
  return axios.post(`${API_ROUTES.download_pdf}`, body);
};
export const getEventListService = (body) => {
  return axios.post(`${API_ROUTES.get_events}`, body);
};
export const getEventCountService = (body) => {
  return axios.post(`${API_ROUTES.get_events_count}`, body);
};
export const getEventOriginalImageService = (event_id) => {
  return axios.post(`${API_ROUTES.get_event_image}?id=${event_id}`);
};
export const getEventSummaryDetailsService = (body) => {
  return axios.post(`${API_ROUTES.get_summary_data}`, body);
};
export const getEventCountingCameraDropdown = (body) => {
  return axios.post(`${API_ROUTES.get_counting_camera_dropdown}`, body);
};
export const getEventCountingDetailsService = (body) => {
  return axios.post(`${API_ROUTES.get_counting_data}`, body);
};
export const getEventCountingSummaryIdsService = (body) => {
  return axios.post(`${API_ROUTES.get_summary_ids}`, body);
};
export const resetEventCameraCounting = (body) => {
  return axios.post(`${API_ROUTES.reset_camera_counting}`, body);
};

export const getEmotionSummaryFiltersService = () => {
  return axios.get(`${API_ROUTES.filter_data}`);
};
export const getEmotionSummaryService = (body) => {
  return axios.post(`${API_ROUTES.get_summary}`, body);
};
export const downloadEmotionSummaryExcelService = (body) => {
  return axios.post(`${API_ROUTES.download_summary_excel}`, body);
};
export const getEmotionSummaryDetailsService = (body) => {
  return axios.post(`${API_ROUTES.get_summary_details}`, body);
};
export const downloadEmotionSummaryDetailsCSVService = (body) => {
  return axios.post(`${API_ROUTES.download_summary_details_csv}`, body);
};
export const getEmotionHomePageSummaryService = (body) => {
  return axios.post(`${API_ROUTES.get_home_page_summary}`, body);
};
export const Getemotions = (body) => {
  return axios.post(`${API_ROUTES.get_emotions}`, body);
};

export const getAttendanceLiveClassSummaryService = () => {
  return axios.get(`${API_ROUTES.get_live_class_summary}`);
};
export const getAttendanceVideoService = (id, name) => {
  return axios.get(API_ROUTES.getVideo(id, name), {
    header: { responseType: "blob" },
  });
};

export const addStudentService = (body) => {
  return axios.post(`${API_ROUTES.add_student}`, body);
};

export const uploadStudentCSVService = (body) => {
  return axios.post(`${API_ROUTES.upload_students_csv}`, body);
};

export const bulkUploadStudentsCSV = async (csvFile) => {
  try {
    const formData = new FormData();
    formData.append('file', csvFile);
    const response = await axios.post(
      `${API_ROUTES.upload_students_csv}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'blob' }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadStudentPhotosZIPService = (body) => {
  return axios.post(`${API_ROUTES.upload_students_zip}`, body);
};

export const deleteStudentService = (body) => {
  return axios.post(`${API_ROUTES.delete_student}`, body);
};

export const getStudentsBySessionService = (body) => {
  return axios.post(`${API_ROUTES.get_students_by_session}`, body);
};

export const getStudentsByDateService = (body) => {
  return axios.post(`${API_ROUTES.get_students_by_date}`, body);
};

export const getAllStudentsService = (body) => {
  return axios.post(`${API_ROUTES.get_all_students}`, body);
};

export const get_students_by_section = async (section = null) => {
  try {
    const params = new URLSearchParams();
    if (section && section !== 'undefined' && section !== 'null' && section !== '') {
      params.append('section', section);
    }
    const queryString = params.toString();
    const url = `${API_ROUTES.get_students_by_section}${queryString ? '?' + queryString : ''}`;
    const response = await axios.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

export const bulkEnrollStudents = async (enrollmentData) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.bulk_enroll_students}`,
      enrollmentData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const get_all_registered_students = () => {
  return axios.get(`${API_ROUTES.get_all_registered_students}`);
};

export const get_devotee_filter_options = async () => {
  return axios.get(`${API_ROUTES.get_devotee_filter_options}`);
};

export const Getdevoteesummary = (body) => {
  return axios.post(`${API_ROUTES.get_devotee}`, body);
};

export const Get_download_devotee_pdf = (body) => {
  return axios.post(`${API_ROUTES.get_download_devotee_pdf}`, body);
};

export const get_student = async (student_id) => {
  return axios.get(`${API_ROUTES.get_student}/${student_id}`);
};

export const update_student = async (student_id, body) => {
  return axios.put(`${API_ROUTES.update_student}/${student_id}`, body);
};

export const delete_students = async (student_id) => {
  return axios.delete(`${API_ROUTES.delete_students}/${student_id}`);
};

export const addUserService = (body) => {
  return axios.post(`${API_ROUTES.add_user}`, body);
};

export const getAllUserListService = () => {
  return axios.get(`${API_ROUTES.get_all_user}`);
};

export const deleteUserService = (body) => {
  return axios.post(`${API_ROUTES.delete_user}`, body);
};

export const userImageService = () => {
  return axios.get(`${API_ROUTES.user_image}`);
};

export const Filteredcount = (body) => {
  return axios.post(`${API_ROUTES.get_filtered_counting}`, body);
};

export const getPeopleCountingByDateTime = (body) => {
  return axios.post(
    `${apiBaseUrl}reports/people-counting/data-by-date-time`,
    body
  );
};

export const getPeopleCountingLocations = () => {
  return axios.get(
    `${apiBaseUrl}reports/people-counting/locations`
  );
};

export const getPeopleCountingByLocation = (body) => {
  return axios.post(
    `${apiBaseUrl}reports/people-counting/data-by-location`,
    body
  );
};

export const getPeopleCountingByCamera = (body) => {
  return axios.post(
    `${apiBaseUrl}reports/people-counting/data-by-camera`,
    body
  );
};

export const getPeopleCountingHourlyTrend = (body) => {
  return axios.post(
    `${apiBaseUrl}reports/people-counting/hourly-trend`,
    body
  );
};

export const downloadPeopleCountingExcel = (body) => {
  return axios.post(
    `${apiBaseUrl}reports/people-counting/download-excel`,
    body,
    {
      responseType: "blob",
    }
  );
};

export const registerStaffService = (body) => {
  return axios.post(`${API_ROUTES.register_staff}`, body);
};

export const getAllStaffService = () => {
  return axios.get(`${API_ROUTES.get_all_staff}`);
};

export const updateStaffService = (staff_id, body) => {
  return axios.put(`${API_ROUTES.update_staff}/${staff_id}`, body);
};

export const deleteStaffService = (staff_id) => {
  return axios.delete(`${API_ROUTES.delete_staff}/${staff_id}`);
};

export const getStaffByIdService = (staff_id) => {
  return axios.get(`${API_ROUTES.get_staff}/${staff_id}`);
};

export const bulkUploadStaffCSV = async (csvFile) => {
  try {
    const formData = new FormData();
    formData.append('file', csvFile);

    const response = await axios.post(
      `${API_ROUTES.upload_staff_csv}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'blob' }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_staff_summary = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.get_staff_summary}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_staff_stats = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.get_staff_stats}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const download_staff_pdf = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.download_staff_pdf}`,
      payload,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const download_staff_csv = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.download_staff_csv}`,
      payload,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const assignRoleService = async (roleData) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.assign_role}`,
      roleData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const removeRoleService = async (userId) => {
  try {
    const response = await axios.delete(
      `${API_ROUTES.remove_role}/${userId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllUsersWithRolesService = async () => {
  try {
    const response = await axios.get(
      `${API_ROUTES.all_users_with_roles}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCurrentUserRoleService = () => {
  return axios.get(`${API_ROUTES.current_user_role}`);
};

export const getDistinctSectionsService = async () => {
  try {
    const response = await axios.get(
      `${API_ROUTES.get_distinct_sections}`
    );
    return response.data.sections || [];
  } catch (error) {
    throw error;
  }
};

export const getDistinctHostelsService = async () => {
  try {
    const response = await axios.get(
      `${API_ROUTES.get_distinct_hostels}`
    );
    return response.data.hostels || [];
  } catch (error) {
    throw error;
  }
};

export const getDistinctLocationsService = async () => {
  try {
    const response = await axios.get(
      `${API_ROUTES.get_all_locations}`
    );
    return response.data || [];
  } catch (error) {
    throw error;
  }
};

export const getAttendanceByRoleService = async (dateStr = null) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.get_attendance_by_role}`,
      { date_str: dateStr }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudentsByRoleService = async () => {
  try {
    const response = await axios.post(
      `${API_ROUTES.get_students_by_role}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAttendanceSummaryByRoleService = async (dateStr = null) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.attendance_summary_by_role}`,
      { date_str: dateStr }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const downloadResultCSV = (blob, filename) => {
  try {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    throw error;
  }
};

export const get_location_overviews = async (body) => {
  return axios.post(`${API_ROUTES.get_location_overviews}`, body);
};
export const getDateExceptionsService = async (dateStr) => {
  try {
    const response = await axios.get(`/api/date-exceptions/${dateStr}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const deleteSectionFromDateService = async (dateStr, sectionName) => {
  try {
    const response = await axios.delete(
      `/api/date-exceptions/${dateStr}/section/${encodeURIComponent(sectionName)}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteStudentFromDateService = async (dateStr, studentId) => {
  try {
    const response = await axios.delete(
      `/api/date-exceptions/${dateStr}/student/${encodeURIComponent(studentId)}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const deleteDateExceptionsService = async (dateStr) => {
  try {
    const response = await axios.delete(`/api/date-exceptions/${dateStr}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const get_student_tracking = async (payload) => {
  try {
    const response = await axios.post(
      `/student-tracking/get_student_tracking`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMemberLocationReportService = async (params) => {
  return axios.post(`/members/get_location_report`, params);
};

export const getMemberSessionAttendanceService = async (params) => {
  return axios.post(`/members/get_session_attendance_status`, params);
};

export const getMemberLocationsByDateService = async (params) => {
  return axios.post(`/members/get_locations_by_date`, params);
};

export const get_student_detection_logs = async (payload) => {
  try {
    const response = await axios.post(
      `/student-tracking/get_student_detection_logs`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const get_student_location_journey = async (payload) => {
  try {
    const response = await axios.post(
      `/student-tracking/get_student_location_journey`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const get_student_camera_breakdown = async (payload) => {
  try {
    const response = await axios.post(
      `/student-tracking/get_student_camera_breakdown`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const get_student_tracking_filters = async (payload) => {
  try {
    const response = await axios.post(
      `/student-tracking/get_student_tracking_filters`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const get_student_tracking_statistics = async (payload) => {
  try {
    const response = await axios.post(
      `/student-tracking/get_student_tracking_statistics`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const download_student_tracking_pdf = async (payload) => {
  try {
    const response = await axios.post(
      `/student-tracking/download_student_tracking_pdf`,
      payload,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_unknown_location_report = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.get_unknown_location_report}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_unknown_session_status = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.get_unknown_session_status}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const sync_telegram = (payload) => {
  const token = localStorage.getItem("accessToken");
  return axios.put(`${REACT_APP_API_URL}/users/sync_telegram`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const delete_telegram = (chat_id) => {
  const token = localStorage.getItem("accessToken");
  return axios.delete(`${REACT_APP_API_URL}/users/delete_telegram/${chat_id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const get_unknown_locations_by_date = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.get_unknown_locations_by_date}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_unknown_person_detail = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.get_unknown_person_detail}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const label_unknown_person = async (payload) => {
  try {
    const response = await axios.post(
      `${API_ROUTES.label_unknown_person}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_unknown_summary = async () => {
  try {
    const response = await axios.get(
      `${API_ROUTES.get_unknown_summary}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const identifyCustomerService = (body) => {
  const token = localStorage.getItem("accessToken");
  return axios.post(`${REACT_APP_API_URL}/${API_ROUTES.identify_customer}`, body, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
export const publicStaffRegistrationService = (body) => {
  return axios.post(`${REACT_APP_API_URL}/staff/public/register`, body);
};
export const uploadVideoService = (formData) => {
    // Replace 'axiosInstance' or 'api' with whatever your base axios instance is called in this file
    return axios.post(`${REACT_APP_API_URL}/camera/upload_video`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
